<template>
    <div class="comment-replies" v-if="isReady">
        <Header/>

        <Tabs v-if="hasComments"/>

        <Input/>

        <RootCommentList ref="rootCommentList"/>

        <ModalWithError/>
    </div>
</template>

<script>
    import Header from "VueApps/comments/components/Header.vue";
    import Input from "VueApps/comments/components/input/Input.vue";
    import Tabs from "VueApps/comments/components/tabs/Tabs.vue";
    import RootCommentList from "VueApps/comments/components/RootCommentList.vue";
    import {mapState} from 'vuex';
    import {INIT_ACTION} from "VueApps/comments/actions/actions";
    import ModalWithError from "VueApps/comments/components/ModalWithError.vue";
    import {scrollToCommentId} from "VueApps/comments/services/scrollToComment";

    export default {
        name: "Comments",
        components: {
            ModalWithError,
            Header,
            Input,
            Tabs,
            RootCommentList
        },
        props: {
            type: {
                type: String,
                required: true,
            },
            entityId: {
                type: Number,
                required: true,
            },
            order: {
                type: String,
                required: true,
            },
            scrollCommentId: {
                type: Number,
                required: false,
            }
        },
        computed: {
            ...mapState([
                'componentState',
                'isReady',
                'isModalOpen'
            ]),
            count: function () {
                return this.$store.state.componentState.totalCount;
            },
            hasComments: function () {
                return this.$store.state.componentState.totalCount > 0;
            }
        },
        mounted() {
            this.$store.dispatch(INIT_ACTION, {
                entityId: this.entityId,
                type: this.type,
                order: this.order,
            })
                .then(() => {
                    if (this.scrollCommentId === 0) {
                        return
                    }

                    if (this.$store.state.componentState.rootIds.indexOf(this.scrollCommentId) !== -1) {
                        scrollToCommentId(this.scrollCommentId);

                        return;
                    }

                    this.toggleAnswersParentCommentId(this.scrollCommentId)
                });
        },
        methods: {
            /*
            * Проходимся по всем рутовым комментам и их ответам, что бы найти комментарий с нужным id.
            * После этого окрываем все ответы рутового коммента, где найден нужный ответ, и переходим к нему
            */
            toggleAnswersParentCommentId(commentId) {
                const vueRootCommentElementList = this.$refs.rootCommentList.$children;

                for (const i in vueRootCommentElementList) {
                    for (const answerIndex in vueRootCommentElementList[i].answers) {
                        if (vueRootCommentElementList[i].answers[answerIndex].id === commentId) {
                            if (vueRootCommentElementList[i].showPartOfAnswers) {
                                vueRootCommentElementList[i].showNextAnswers();
                                setTimeout(function () {
                                    scrollToCommentId(commentId)
                                }, 1000);

                                return;
                            }

                            scrollToCommentId(commentId);

                            return;
                        }
                    }
                }

                return;
            }
        }
    }
</script>
